import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import {
    name,
    version,
} from "../package.json";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

if (typeof window !== "undefined") {
    // eslint-disable-next-line
    const connection = (navigator as any).connection
        // eslint-disable-next-line
        ?? (navigator as any).mozConnection
        // eslint-disable-next-line
        ?? (navigator as any).webkitConnection;

    Sentry.init({
        dsn: "https://8cfc6fa5e7c921b5412de20cc2443dad@o4504559517171712.ingest.us.sentry.io/4511420563718144",
        beforeSend(event) {
            if (connection) {
                event.contexts = {
                    ...event.contexts,
                    network: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
                        effective_type: connection.effectiveType,
                        downlink: connection.downlink,
                        rtt: connection.rtt,
                        // eslint-disable-next-line @typescript-eslint/naming-convention,camelcase
                        save_data: connection.saveData,
                    },
                };
                event.tags = {
                    ...event.tags,
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    "network.effective_type": connection.effectiveType ?? "unknown",
                };
            }
            return event;
        },
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                useCompression: false,
                networkDetailAllowUrls: [
                    "localhost",
                    /^https:\/\/aerobet-portal\.devsoft-kernel\.com/,
                    // /^https:\/\/service-aerobet-flex\.devsoft-kernel\.com\/.*/,
                    /^https:\/\/aerobet-portal\.aerobet[0-9]*\.com/,
                    /^https:\/\/service-aerobet-flex\.aerobet[0-9]*\.com/,
                ],
                networkCaptureBodies: true,
                networkRequestHeaders: ["Content-Type", "Accept-Encoding"],
                networkResponseHeaders: ["Content-Type", "Content-Encoding", "Content-Length"],
            }),
            Sentry.httpClientIntegration({
                // Capture HTTP client errors
                failedRequestTargets: [
                    // Monitor all API requests
                    /^https?:\/\//,
                ],
            }),
            // send console.log, console.warn, and console.error calls as logs to Sentry
            Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
        ],
        // Tracing
        tracesSampleRate: environment.domain === "PROD" ? 0.1 : 1.0, //  Capture 10% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/aerobet-portal\.devsoft-kernel\.com/,
            // /^https:\/\/service-aerobet-flex\.devsoft-kernel\.com\/.*/,
            /^https:\/\/aerobet-portal\.aerobet[0-9]*\.com/,
            /^https:\/\/service-aerobet-flex\.aerobet[0-9]*\.com/,
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: environment.domain,
        // Enable source maps
        release: `${name}@${version}`,
        attachStacktrace: true, // Attach stack traces to all messages
        enableLogs: true,
    });
}

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        if (typeof document !== "undefined") {
            const loader = document.getElementById("app-loader");
            if (loader) {
                loader.remove();
            }
        }
    })
    .catch((err) => console.error(err));
